import { render, staticRenderFns } from "./ReportGen.vue?vue&type=template&id=849be1b8&scoped=true"
import script from "./ReportGen.vue?vue&type=script&lang=js"
export * from "./ReportGen.vue?vue&type=script&lang=js"
import style0 from "./ReportGen.vue?vue&type=style&index=0&id=849be1b8&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849be1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849be1b8')) {
      api.createRecord('849be1b8', component.options)
    } else {
      api.reload('849be1b8', component.options)
    }
    module.hot.accept("./ReportGen.vue?vue&type=template&id=849be1b8&scoped=true", function () {
      api.rerender('849be1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/ReportGen.vue"
export default component.exports